<template>
  <ObDialog v-model:visible="visible" :footer="false" :close-on-click-overlay="false">
    <div class="label-container">
      <div class="label-top">
        <div class="label-title">{{ $t('mediaLabel') }}</div>
        <div class="label-close">
          <svg-icon @click="closeLabel" class="icon-close" name="icon-close"></svg-icon>
        </div>
      </div>
      <div class="label-content">
        <el-scrollbar height="430px">
          <div class="media-container">
            <div v-for="(item, index) in mediaList" :key="index" class="label-item" @click="selectMedia(item, index)">
              <template v-if="!item.oliveInfo">
                <el-image v-if="item.type === 1" :src="item.url"></el-image>
                <video v-if="item.type === 2" :src="item.url"></video>
                <div class="youtube" v-if="item.type === 3">
                  <svg-icon name="icon-youtube"></svg-icon>
                </div>
                <div class="media-icon">
                  <!-- <svg-icon v-if="item.type === 1" name="icon-label-image"></svg-icon>
                  <svg-icon v-if="item.type === 2" name="icon-label-video"></svg-icon> -->
                  <span class="vedio-label" v-if="item.type === 3 || item.type === 2">{{ $t('video') }}</span>
                  <span class="added-label" v-if="item.selected">{{ $t('addedLabel') }}</span>
                </div>
                <div class="select">
                  <span v-if="!item.isActive" class="circle"></span>
                  <span v-if="item.isActive" class="vector">
                    <svg-icon name="icon-vector"></svg-icon>
                  </span>
                </div>
                <div v-if="item.isActive" class="selected-border-box"></div>
              </template>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="label-bottom">
        <el-button @click="selectAll" class="all">{{ $t('selectedAll') }}</el-button>
        <el-button @click="selectNext" :disabled="!selectedMedia().length" class="select">({{ $t('selectMedia', {n: selectedMedia().length}) }}) {{ $t('next') }}</el-button>
      </div>
    </div>
  </ObDialog>
  <AddLabel v-model="addLabelVisible" :threadInfo="threadInfo" :media="selectedMedia()" @closeAll="() => {visible = false}"></AddLabel>
</template>
<script setup>
import { ref, watch, onMounted, nextTick, computed, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import http from '@/service'
import Bricks from 'bricks.js'

const route = useRoute()
const { proxy } = getCurrentInstance()
const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  threadInfo: {
    type: Object,
    default: () => {}
  }
})
const visible = ref(false)
const mediaList = ref([])
const addLabelVisible = ref(false)
if (props.threadInfo?.attachments?.length) {
  props.threadInfo.attachments.forEach((item) => {
    if(!item.oliveInfo){
      mediaList.value.push({...item,isActive: false,selected: false})
    }
  })
}
if (props.threadInfo?.ext?.length) {
  props.threadInfo.ext.forEach((item, index) => {
    mediaList.value.push({
      id: null,
      url: item.url,
      type: 3,
      index: index,
      isActive: false,
      selected: false
    })
  })
}
const closeLabel = () => {
  visible.value = false
  proxy.$toast({
    message: proxy.$t('labelNotSaved')
  })
}
const selectMedia = (item, index) => {
  console.log(item)
  // // 获取已选中视频中已打过标签的视频数量
  // const addedLength = mediaList.value.filter((item) => {
  //   return item.isActive && item.selected
  // }).length
  // // 获取已选中视频数量
  // const selectLength = mediaList.value.filter((item) => {
  //   return item.isActive
  // }).length
  // // 如果列表中有selected (已经添加过标签的媒体资源)，则不能进行多选
  // let next = true
  // if (addedLength > 0 || (item.selected && selectLength > 0)) {
  //   next = false
  // }
  // // 列表中已存在selected并且继续勾选、需要阻止选择并弹窗
  // if (!next && !item.isActive) {
  //   proxy.$toast({
  //     message: proxy.$t('seletedOnce')
  //   })
  //   return
  // }
  // 改变选中/未选中状态
  mediaList.value[index].isActive = !item.isActive
}
// 获取已选择
const selectedMedia = () => {
  return mediaList.value.filter((item) => {
    return item.isActive
  })
}
const selectAll = () => {
  // // 如果存在已添加过标签的媒体自选，只能全选未添加的
  // const seletedLength = mediaList.value.filter((item) => {
  //   return item.selected
  // }).length
  // // 当存在已打过标签的情况
  // if (seletedLength) {
  //   const activeLength = mediaList.value.filter((item) => {
  //     return item.isActive
  //   }).length
  //   // 当所有的媒体资源全部都打过标签的情况，并且未选择过，点击全选弹出提示
  //   if ((seletedLength === mediaList.value.length) && !activeLength) {
  //     proxy.$toast({
  //       message: proxy.$t('someNotSelected')
  //     })
  //     return
  //   }
  //   // 选中了所有所有未打过标签的，再次点击全选需要取消选中
  //   if (activeLength === mediaList.value.length - seletedLength) {
  //     mediaList.value.forEach((item) => {
  //       item.isActive = false
  //     })
  //     return
  //   }
    
  //   proxy.$toast({
  //     message: proxy.$t('someNotSelected')
  //   })
  //   return
  // }
  // mediaList.value.forEach((item) => {
  //   item.isActive = false
  //   if (!item.selected) {
  //     item.isActive = true
  //   }
  // })
  // 选中了所有，取消全选
  const isSelectAll = selectedMedia().length === mediaList.value.length
  mediaList.value.forEach((item) => {
    item.isActive = isSelectAll ? false : true
  })
}
const selectNext = () => {
  addLabelVisible.value = true
}
const getCheckedMedias = async () => {
  const { code, data, msg } = await http.getThreadMedia({
    parentId: route.params.id
  })
  if (code === 200 && data) {
    // 清空已选择视频
    mediaList.value.forEach((media) => {
      media.isActive = false
      media.selected = false
    })
    if (data.length) {
      data.forEach((item) => {
        mediaList.value.forEach((media) => {
          if (item.id === media.id || item.url === media.url) {
            media.selected = true
            media.id = item.id
          }
        })
      })
      
    }
  }
}
watch(() => props.modelValue, async (val) => {
  visible.value = val
  if (val) {
    // 获取已选择附件列表
    await getCheckedMedias()
    const instance = Bricks({
      container: '.media-container',
      packed: 'data-packed',
      sizes: [
        { columns: 3, gutter: 12 },
        { mq: '768px', columns: 3, gutter: 12 },
      ],
      position: true
    })
    instance.resize(true);
    instance.pack();
  }
})
watch(() => visible.value, (val) => {
  if (!val) {
    emit('update:modelValue', val)
  }
})
</script>
<style scoped lang="postcss">
.label-container {
  width: 868px;
  height: 674px;
  .label-top {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 40px;
    box-sizing: border-box;
    box-shadow: 0px 1px 0px #F5F5F5;
    .label-title {
      font-size: 28px;
      color: var(--text-primary);
      font-family: 'orbit-M';
    }
    .icon-close {
      margin-left: 20px;
      width: 32px;
      height: 32px;
      color: var(--text-primary);
    }
  }
  .label-content {
    height: 430px;
    box-shadow: 0px 1px 0px #F5F5F5;
    margin-left: 33.5px;
    .label-item {
      position: relative;
      cursor: pointer;
      display: inline-block;
      margin: 6px;
      font-size: 0;
      video {
        width: 255px;
        transition: padding 0.3s ease;
        box-sizing: border-box;
      }
      .el-image {
        width: 255px;
        display: inline-block;
        box-sizing: border-box;
        background-clip: content-box;
      }
      div {
        display: inline-block;
      }
      &.label-active {
        .youtube,.el-image {
          border: 3px solid var(--text-primary);
          padding: 4px;
        }
      }
      .youtube {
        width: 255px;
        height: 140px;
        background: #ebebeb;
        display: flex;
        align-items: center;
        justify-content: center;
        background-clip: content-box;
        box-sizing: border-box;
        .icon-youtube {
          width: 120px;
          height: 120px;
        }
      }
      .media-icon {
        position: absolute;
        bottom: 12px;
        left: 12px;
        .svg-icon {
          width: 30px;
          height: 30px
        }
        span {
          background: rgba(0, 0, 0, 0.4);
          padding: 0 3px;
          color: var(--text-primary-reverse);
          font-size: 12px;
          border-radius: 3px;
          display: inline-block;
        }
        .vedio-label {
          margin-right: 4px;
        }
        .added-label {
          background: rgba(0, 0, 0, 0.75);
        }
      }
      .select {
        position: absolute;
        right: 13px;
        top: 13px;
        span.circle {
          width: 18px;
          height: 18px;
          box-sizing: border-box;
          border-radius: 50%;
          border: 1.5px solid #ccc;
          display: inline-block;
        }
        span.vector {
          background: var(--theme);
          display: inline-block;
          border-radius: 50%;
          width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          .svg-icon {
            color: var(--text-primary-reverse);
            width: 14px;
            height: 8px;
            margin-top: 1px;
          }
        }
      }
    }
    .selected-border-box {
      position: absolute;
      width: 100%;
      height: 100%;
      border: 3px solid var(--text-primary);
      left: 0;
      top: 0;
      box-sizing: border-box;
    }
    .selected-border-box:after {
      position: absolute;
      width: 100%;
      height: 100%;
      content: '';
      left: 0;
      top: 0;
      border: 3px solid var(--background-white);
      box-sizing: border-box;
    }
  }
  .label-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 124px;
    padding: 0 40px;
    .el-button.all {
      width: 150px;
      border-color: #DCDCDC;
      color: var(--text-primary);
      background: transparent;
    }
    .el-button.select {
      margin-left: 24px;
      width: 100%;
    }
    .el-button {
      width: 280px;
      height: 52px;
      font-size: 16px;
      color: var(--text-primary-reverse);
      font-family: 'orbit-M';
      background: var(--theme);
      border-radius: var(--button-radius);
    }
    .el-button.is-disabled {
      background: var(--theme-disabled);
    }
  }
}
</style>